import { Produkt } from "./organizacje";

export const settingsConst = {
  DAJ_DOSTEPNE_PRODUKTY_REQUEST: "DAJ_DOSTEPNE_PRODUKTY_REQUEST",
  DAJ_DOSTEPNE_PRODUKTY_SUCCESS: "DAJ_DOSTEPNE_PRODUKTY_SUCCESS",
  DAJ_DOSTEPNE_PRODUKTY_FAILURE: "DAJ_DOSTEPNE_PRODUKTY_FAILURE",
};

export interface SettingsAction {
  type: string;
  produkty: Produkt[];
  error: string;
}
